import React, { useEffect, useState } from "react";
import '../checkout/style/checkout.css';
import Breadcrumb from "../../Component/breadcrumb/Breadcrumb";
import { Link } from "react-router-dom";
import { Button } from 'react-bootstrap';
import DeliveryInformation from "../../Component/Common/DeliveryInformation";
import { gettransporters } from "./service/transporters.service";
import { useDispatch, useSelector } from "react-redux";
import { fetchSummary } from "../checkout/redux/summarySlice";

function Summarys() {
  const dispatch = useDispatch();
  const [transporters, setTransporters] = useState([]);
  const { summary, loading } = useSelector(
    (state) => state.summary
  );
  const checkoutId = "6b1f75fa-76a0-11f1-ae7e-50bbb51625fb";

  useEffect(() => {
    dispatch(fetchSummary(checkoutId));
    loadTransporters();
  }, [dispatch]);

  const loadTransporters = async () => {
    try {
      const res = await gettransporters();
      setTransporters(res?.data || []);
    } catch (error) {
      console.log("Transporter Error:", error);
    }
  };

  if (loading) {
    return <h4>Loading...</h4>;
  }

  return (
    <>

    <Breadcrumb />

      <div className="TableBoxCheckout">
        <div className="container">
          <div className="row">
            <div className="col-md-9 col-sm-12">
              <div className="row">
                <div className="col-md-4">
                  <div className="p-2" style={ {border:" 1px solid rgb(222, 222, 222)", minHeight:"153px", marginBottom: "10px ", maxHeight:"300px"}}> 
                  <p className="text-sm mb-1"><strong>Customer Information</strong></p>
                  <p className="text-sm P-text">
                      {summary?.customer?.name} <br />
                      Address:  {summary?.customer?.address} <br />
                      Mobile:   {summary?.customer?.mobile} <br />
                      Email:   {summary?.customer?.email} <br />
                      GST No.: {summary?.customer?.gst_no}
                  </p>
                  </div>
                </div>

                <div className="col-md-4 col-sm-12">
                  <div className="p-2" style={ { border:" 1px solid rgb(222, 222, 222)", minHeight:"153px", marginBottom: "10px " }}>
                  <p className="text-sm mb-1"><strong>Delivery Information</strong></p>
                  <p className="text-sm P-text mb-1">
                      {/* Usually Dispatched Within 2 to 3 Days
                      Delivery to: 17A/39, WEA, GANESH NAGAR17A/39, WEA, GANESH NAGAR, 166, DELHI, 110005 */}
                      {summary?.delivery?.message} <br/>
                      {summary?.delivery?.address}
                  </p>

                 <DeliveryInformation 
                    transporters={transporters}
                    onChange={(selected) => {
                      console.log("Selected Transporter:", selected);
                    }}
                  />
                  </div>
                </div>

                <div className="col-md-4">
                   <div className="p-2" style={ { border:" 1px solid rgb(222, 222, 222)", minHeight:"153px", marginBottom: "10px ", maxHeight:"300px" }}>
                  <p className="text-sm mb-1"><strong>Order Details</strong></p>
                  <p className="text-sm P-text">
                    Order Date: {summary?.order?.date}  <br />
                    ASM/RSM:  {summary?.order?.asm}
                  </p>
                  <textarea name="" placeholder="Enter Remark" className="form-control control-input"></textarea>
                  </div>
                </div>
              </div>

              <div className="table-box-content">
                <div className="table-responsive">
                  <table className="table table-lg table-boxrto mb-0" style={{ width: "100%" }}>
                    <thead className="text-center">
                      <tr>
                        <th className="table-header" width="75"> Image </th>
                        <th className="table-header">Design & Shade</th>
                        <th className="table-header">Size</th>
                        <th className="table-header">Stock</th>
                        <th className="table-header">Order Qty.</th>
                        <th className="table-header">GST%</th>
                        <th className="table-header">MRP (<i className="bi bi-currency-rupee"></i>) </th>
                        <th className="table-header">Amount</th>
                        <th className="table-header" width="90"> &nbsp; </th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                      summary?.items?.map((item)=>(
                        <tr key={item.id}>

                        <td className="align-middle" width="75">
                          <img className="img-fluid" style={{ fontSize: "13px", padding: "3px", width: "50px", height: "auto" }} src={item.image} alt="product-1" />
                        </td>
                        <td className="align-middle" width="215"><Link to="/" style={{ fontSize: "12px" }}> {item.design_name} </Link> </td>
                        <td className="align-middle text-center">  {item.size} </td>
                        <td className="align-middle text-center">  {item.stock} </td>
                        <td className="align-middle text-center">
                          <select className="form-control">
                              <option>
                                {item.qty}
                              </option>
                            </select>
                        </td>
                        <td className="align-middle">  {item.gst} </td>
                        <td className="align-middle text-center"> ₹ {item.mrp} </td>
                        <td className="align-middle text-center"> ₹ {item.amount} </td>
                        <td className="align-middle text-center">
                          <div className="customer-selected-cart">
                            <button type="button" className="btn btn-sm btn-outline-secondary addtocart" title="Add to Cart">
                              <i className="fa fa-spinner fa-spin d-none" id="spinner_31185"></i>
                              <i className="bi bi-trash"></i>
                            </button>
                          </div>
                        </td>
                      </tr>

                     ))
                    }
                       
                        {/*---- Repeat rows as necessary-----*/}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="box-amount">
                <Button className="btn btnprimary mb-1" style={{ border: "none" }}> ORDER Summary </Button>
                <div className="d-flex">
                  <span> Order Qty. </span>
                  <div className="ml-auto"><span style={{ marginLeft: "-37px" }} className="update-qty">   {summary?.totals?.qty}  </span></div>
                </div>
                <div className="d-flex">
                  <span> Taxable Value </span>
                  <div className="ml-auto"><span style={{ marginLeft: "-37px" }} className="update-qty"> <i className="bi bi-currency-rupee"></i>{summary?.totals?.taxable} </span></div>
                </div>
                <div className="d-flex">
                  <span> GST Amount </span>
                  <div className="ml-auto"><span style={{ marginLeft: "-37px" }} className="update-qty"> <i className="bi bi-currency-rupee"></i>{summary?.totals?.gst} </span></div>
                </div>
                <div className="d-flex">
                  <span> Total Amount </span>
                  <div className="ml-auto"><span style={{ marginLeft: "-37px" }} className="update-qty"> <i className="bi bi-currency-rupee"></i>{summary?.totals?.total} </span></div>
                </div>
                <div className="d-flex">
                  <span style={{ fontSize: "12px" }}> {summary?.totals?.amount_words} </span>
                </div>
                <Button className="btn btnyellow mt-1" style={{ backgroundColor: "#f7d42e", border: "none" }}> ORDER NOW </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Summarys;
